import { useCallback } from "react";
import { importData, type ImportedData } from "~utils/fileTransfer";

/**
 * Hook that returns a function to import a File (CSV/XLSX) and parse it
 */
export function useFileImport() {
  return useCallback(
    (file: File, type: "xlsx" | "csv"): Promise<ImportedData> => {
      return importData(file, type);
    },
    []
  );
}
